export function singleField(arr: any[], field: string){
    return arr.map(function(element) {
        return element[field];
    })
}

export function maxByField(arr: any[], field: any) {
    var max = -Infinity;
    for (var i = 0; i < arr.length; i++){
        max = Math.max(arr[i][field], max);
    }
    return max;
}

export function averageByField(arr: any[], field: any){
    var sum = 0;
    for (var i = 0; i < arr.length; i++){
        sum+=arr[i][field];
    }
    return sum/arr.length;
}

export function sumByField(arr: any[], field: any) {
    var sum = 0;
    for (var i = 0; i < arr.length; i++){
        sum+=arr[i][field];
    }
    return sum;
}

export function groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}